import { RESERVE_VS_STUDIO_CONTENT } from '../constants/reserveVsStudioContent'

function PointBlock({ label, text }) {
  return (
    <div className="space-y-1">
      <p className="font-poppinsSemiBold text-black text-[15px] sm:text-base">
        {label}:
      </p>
      <p className="font-poppinsLight text-neutral-700 text-[15px] sm:text-base leading-relaxed">
        {text}
      </p>
    </div>
  )
}

const ReserveVsStudioWelcomePack = () => {
  const c = RESERVE_VS_STUDIO_CONTENT

  return (
    <div className="text-black">
      <header className="text-center space-y-3 sm:space-y-4 mb-10 sm:mb-12 max-w-xl mx-auto">
        <p className="font-AXONALLPrimeMedium text-[11px] sm:text-xs uppercase tracking-[0.28em] text-neutral-600">
          {c.brand}
        </p>
        <h2 className="font-AXONALLPrimeSemiBold text-2xl sm:text-3xl md:text-[2rem] text-black tracking-tight leading-tight">
          {c.headline}
        </h2>
        <p className="font-poppinsRegular text-base sm:text-lg italic text-neutral-700">{c.subtitle}</p>
      </header>

      <div className="border border-black bg-neutral-200/40 px-5 py-5 sm:px-7 sm:py-6 mb-10 sm:mb-12">
        <p className="font-poppinsLight text-[15px] sm:text-base leading-relaxed text-neutral-800 text-center sm:text-left">
          {c.summary}
        </p>
      </div>

      <div className="border border-black overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2">
          <section className="px-5 py-8 sm:px-7 sm:py-10 border-b md:border-b-0 md:border-r border-black bg-white">
            <h3 className="font-AXONALLPrimeSemiBold text-sm sm:text-base uppercase tracking-[0.12em] text-black mb-8">
              {c.reserve.title}
            </h3>
            <div className="space-y-8">
              {c.reserve.points.map((p) => (
                <PointBlock key={p.label} label={p.label} text={p.text} />
              ))}
            </div>
          </section>
          <section className="px-5 py-8 sm:px-7 sm:py-10 bg-neutral-100">
            <h3 className="font-AXONALLPrimeSemiBold text-sm sm:text-base uppercase tracking-[0.12em] text-black mb-8">
              {c.studio.title}
            </h3>
            <div className="space-y-8">
              {c.studio.points.map((p) => (
                <PointBlock key={p.label} label={p.label} text={p.text} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default ReserveVsStudioWelcomePack
